import React, {Ref, useCallback, useState} from 'react';
import {Subject} from 'rxjs';
import {isFunction} from 'underscore';
import {DetailedProps, useStream} from '@esgi/ui-kit/utils';
import FormElementContext, {FormElementContextState} from './form-element/form-element-context';
import {ElementStatus} from './types';

type Props<T> = {subject: Subject<T>, children?: any} & DetailedProps<HTMLDivElement> & {ref?: Ref<HTMLDivElement>}

/**
* @deprecated Do not use this component.
* */
export function ReactiveElement<T>({subject, children, ...divProps}: Props<T>): JSX.Element {
	const value = useStream(subject);
	const setValue = useCallback((next: T) => subject.next(next), [subject]);

	const [status, setStatus] = useState(ElementStatus.untouched);
	const [ref, setRef] = useState();
	const elementContext = {
		value,
		status,
		validate: (silence?: boolean) => undefined,
		hasError: (errorType: string) => false,
		setStatus,
		setValue,
		setRef,
		ref,
	} as FormElementContextState;

	return <FormElementContext.Provider value={elementContext}>
		<div {...divProps}>
			{isFunction(children) ? children(elementContext) : children}
		</div>
	</FormElementContext.Provider>;
}
